import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ProjectModal from '../components/ProjectModal';
import { API_BASE_URL, getAuthHeaders } from '../utils/api';
import './ProjectSettingsPage.css';

const ProjectSettingsPage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnSessionId = searchParams.get('session') || '';
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);

  const backTarget = returnSessionId && projectId
    ? `/p/${projectId}/c/${returnSessionId}`
    : (projectId ? `/p/${projectId}` : '/projects');

  const loadProject = useCallback(async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const headers = await getAuthHeaders();
      const resp = await fetch(`${API_BASE_URL}/casc/v1/api/chat/project/get`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ projectId }),
      });
      const json = await resp.json().catch(() => ({}));
      if (resp.ok && json?.success && json.data) {
        setProjectData(json.data);
      }
    } catch (e) {
      console.error('Failed to load project:', e);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => { loadProject(); }, [loadProject]);

  if (loading) {
    return (
      <div className="project-settings-page">
        <div style={{ padding: 24, color: '#6b7280' }}>
          <i className="fas fa-spinner fa-pulse" /> Loading project settings…
        </div>
      </div>
    );
  }

  return (
    <div className="project-settings-page">
      <ProjectModal
        mode="edit"
        initial={projectData || { project_id: projectId }}
        onClose={() => navigate(backTarget)}
        onSaved={(project) => {
          navigate(backTarget);
        }}
      />
    </div>
  );
};

export default ProjectSettingsPage;